module.exports = __webpack_public_path__ + "img/financiele-positie.b9aa4366.png";